<template>
    <span class="k-num-rate" :class="className">
        <span class="rate_num">{{text}}</span><span class="rate_per">%</span>
    </span>
</template>

<script>
    export default {
        name: 'k-num-rate',
        props: ['value'],
        computed: {
            className() {
                return this.value < 0 ? 'cl_fall' : this.value > 0 ? 'cl_rise' : 'cl_flat'
            },
            text() {
                return (this.value < 0 ? '' : '+') + (this.value *
                    100).toFixed(2)
            }
        }
    };
</script>
